@if (showAvatar()) {
    @let badge = vm?.OriginatorBadge | async;
    <aurora-avatar
        id="notificationAvatar"
        size="small"
        [user]="toAuroraAvatarUser(badge)"
        [color]="toAuroraAvatarColor(badge)"
        [isCurrentUser]="!!badge?.IsCurrentUser">
    </aurora-avatar>
} @else {
    <aurora-icon class="avatar-icon" [icon]="getAvatarIcon()"/>
}

<h2 id="notificationTitle">{{ vm?.Message }}</h2>

<div *ngIf="!vm?.IsMarkedForDelete" class="time_actions">
    <sm-time-since class="card-title-time-since" [start]="vm?.CreatedOnDate"></sm-time-since>
    <aurora-icon-button
        id="deleteNotification"
        (click)="onDeleteNotification()"
        icon="trash"
        size="large"
        label="Delete notification">
    </aurora-icon-button>
</div>

<aurora-link-button id="undoDeleteNotification" *ngIf="vm?.IsMarkedForDelete" size="small" iconRight="undo" class="undo" (click)="onUndoDelete()">
    undo delete
</aurora-link-button>

<ng-container *ngFor="let subtitle of vm.Subtitles">
    <div *ngIf="!vm?.IsMarkedForDelete" id="notificationEntity" class="subline">
        {{ subtitle?.DisplayEntityType ?? subtitle?.EntityType }}:
        @if (subtitle?.IsLink) {
            @if (subtitle.EntityType == 'Email') {
                <aurora-link-button
                    [attr.id]="'notificationEntityLink:' + subtitle.EntityType + ':' + subtitle.EntityId"
                    size="small"
                    prominence="low"
                    (click)="openMailTo(subtitle?.EntityText)">
                    {{subtitle?.EntityText || 'Email ' + (subtitle?.DisplayEntityType ?? subtitle?.EntityType) }}
                </aurora-link-button>
            } @else {
                <aurora-link-button
                    [attr.id]="'notificationEntityLink:' + subtitle.EntityType + ':' + subtitle.EntityId"
                    size="small"
                    prominence="low"
                    (click)="onClickLink.emit(vm)">
                    @if (subtitle.EntityType == 'Download') {
                        file
                    } @else {
                        {{subtitle?.EntityText || 'Go to ' + (subtitle?.DisplayEntityType ?? subtitle?.EntityType) }}

                    }
                </aurora-link-button>
            }

        } @else {
            {{subtitle?.EntityText}}
        }

    </div>
</ng-container>

<div
    *ngIf="vm?.Description && !vm?.IsMarkedForDelete"
    class="description" [ngClass]="{ 'overflow': needsShowMoreShowLess}"
    [class.collapsed]="isCollapsed"
    [class.overflow]="isOverflow"
    (click)="toggleDescription()"
>
    <span id="notificationDescription">{{vm?.Description}}</span>
</div>
